import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { logOut as logOutHandler } from '../common/Components/UserManagement/controllers/actions';
import { useAppDispatch } from 'store';
import { RESET_STORE } from '../common/Components/MasterSlave/controllers/const';
import { isSiteTypeSitesContainer } from 'common/Helpers/Sites/SitesHelper';

function useLoggedUser() {
  const dispatch = useAppDispatch();
  const masterSlave = useSelector((state: RootState) => state.masterSlave);
  const { loggedUser } = useSelector((state: RootState) => state.user);

  const loggedClient = masterSlave?.masterSlave?.SlaveDetails?.find(
    (s: any) => s.DbTenantId === masterSlave?.masterSlave.CurrentSiteGuid
  );

  const isLoggedClientSitesContainer = isSiteTypeSitesContainer(loggedClient?.SiteType);

  const logOut = (reasonCode: number) => {
    dispatch({ type: RESET_STORE });
    logOutHandler(reasonCode);
  };

  return {
    loggedUser,
    logOut,
    isGlobalMode:
      loggedUser.isGlobalMode && (!masterSlave?.masterSlave.CurrentyLoggedClient || isLoggedClientSitesContainer),
    isUserLoaded: loggedUser?.userId !== undefined
  };
}

export default useLoggedUser;
